"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBadgeLink = exports.badges = exports.badgeSize = exports.StatusBadge = void 0;
var core_1 = require("@emotion/core");
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var react_aria_components_1 = require("react-aria-components");
var icons_1 = require("../icons");
var focusRingStyles_1 = require("../rac/focusRingStyles");
var theme_1 = require("../theme");
var StatusBadge = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'NOT_RUNNING' : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, children = _a.children;
    var icon = exports.badges[type].icon;
    return children ? (React.createElement(StatusBadgeContainer, { type: type, size: 'regular' },
        icon,
        children)) : (React.createElement(StatusBadgeContainer, { type: type, size: size }, icon));
};
exports.StatusBadge = StatusBadge;
exports.badgeSize = theme_1.theme.space.space20;
exports.badges = {
    RUNNING: {
        icon: React.createElement(icons_1.StatusRunningIcon, null),
        backgroundColor: theme_1.theme.colors.blue500,
        hoverBackgroundColor: theme_1.theme.colors.blue600,
        pressedBackgroundColor: theme_1.theme.colors.blue700,
        color: theme_1.theme.colors.white,
    },
    SUCCESS: {
        icon: React.createElement(icons_1.StatusPassedIcon, null),
        backgroundColor: theme_1.theme.colors.green200,
        hoverBackgroundColor: theme_1.theme.colors.green300,
        pressedBackgroundColor: theme_1.theme.colors.green400,
        color: theme_1.theme.colors.green800,
    },
    FAILED: {
        icon: React.createElement(icons_1.StatusFailedIcon, null),
        backgroundColor: theme_1.theme.colors.red500,
        hoverBackgroundColor: theme_1.theme.colors.red600,
        pressedBackgroundColor: theme_1.theme.colors.red700,
        color: theme_1.theme.colors.white,
    },
    NOT_RUNNING: {
        icon: React.createElement(icons_1.StatusCanceledIcon, null),
        backgroundColor: theme_1.theme.colors.n700,
        hoverBackgroundColor: theme_1.theme.colors.n800,
        pressedBackgroundColor: theme_1.theme.colors.n900,
        color: theme_1.theme.colors.contentInverse,
    },
    PAUSED: {
        icon: React.createElement(icons_1.StatusOnHoldIcon, null),
        backgroundColor: theme_1.theme.colors.purple300,
        hoverBackgroundColor: theme_1.theme.colors.purple400,
        pressedBackgroundColor: theme_1.theme.colors.purple500,
        color: theme_1.theme.colors.purple800,
    },
    WAITING: {
        icon: React.createElement(icons_1.StatusQueuedIcon, null),
        backgroundColor: theme_1.theme.colors.n600,
        hoverBackgroundColor: theme_1.theme.colors.n700,
        pressedBackgroundColor: theme_1.theme.colors.n800,
        color: theme_1.theme.colors.contentInverse,
    },
    CREATED: {
        icon: React.createElement(icons_1.StatusCreatedIcon, null),
        backgroundColor: theme_1.theme.colors.khaki100,
        hoverBackgroundColor: theme_1.theme.colors.khaki200,
        pressedBackgroundColor: theme_1.theme.colors.khaki300,
        color: theme_1.theme.colors.khaki800,
    },
    SCHEDULED: {
        icon: React.createElement(icons_1.StatusScheduledIcon, null),
        backgroundColor: theme_1.theme.colors.n600,
        hoverBackgroundColor: theme_1.theme.colors.n700,
        pressedBackgroundColor: theme_1.theme.colors.n800,
        color: theme_1.theme.colors.contentInverse,
    },
    UNAUTHORIZED: {
        icon: React.createElement(icons_1.StatusUnauthorizedIcon, null),
        backgroundColor: theme_1.theme.colors.warning,
        hoverBackgroundColor: theme_1.theme.colors.bronze300,
        pressedBackgroundColor: theme_1.theme.colors.bronze400,
        color: theme_1.theme.colors.warningContrast,
    },
    WARNING: {
        icon: React.createElement(icons_1.StatusSetupNeededIcon, null),
        backgroundColor: theme_1.theme.colors.warning,
        hoverBackgroundColor: theme_1.theme.colors.bronze400,
        pressedBackgroundColor: theme_1.theme.colors.bronze500,
        color: theme_1.theme.colors.warningContrast,
    },
    EXTERNAL: {
        icon: React.createElement(icons_1.StatusExternalIcon, null),
        backgroundColor: theme_1.theme.colors.blue500,
        hoverBackgroundColor: theme_1.theme.colors.blue600,
        pressedBackgroundColor: theme_1.theme.colors.blue700,
        color: theme_1.theme.colors.white,
    },
    LOGGED: {
        icon: React.createElement(icons_1.StatusPassedIcon, null),
        backgroundColor: theme_1.theme.colors.surface200,
        color: theme_1.theme.colors.contentPrimary,
        borderColor: theme_1.theme.colors.n900,
        hoverBackgroundColor: theme_1.theme.colors.n60,
        pressedBackgroundColor: theme_1.theme.colors.n80,
    },
};
var StatusBadgeContainer = (0, styled_1.default)('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: ", ";\n  font-size: ", ";\n  background: ", ";\n  color: ", ";\n  height: 1.8rem;\n  border-radius: 14px;\n  width: fit-content;\n  padding: ", " ", ";\n  align-items: center;\n  border: ", ";\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: ", ";\n  font-size: ", ";\n  background: ", ";\n  color: ", ";\n  height: 1.8rem;\n  border-radius: 14px;\n  width: fit-content;\n  padding: ", " ", ";\n  align-items: center;\n  border: ", ";\n\n  ", "\n"])), theme_1.theme.fontWeights.medium, theme_1.theme.fontSizes.small, function (props) { return exports.badges[props.type].backgroundColor; }, function (props) { return exports.badges[props.type].color; }, theme_1.theme.space.space4, theme_1.theme.space.space12, function (props) {
    return exports.badges[props.type].borderColor
        ? '1px solid ' + exports.badges[props.type].borderColor
        : 'none';
}, function (props) { return StatusBadgeSizeVariants[props.size]; });
var StatusBadgeStyles = function (_a) {
    var type = _a.type, size = _a.size;
    return (0, core_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: ", ";\n  font-size: ", ";\n  background: ", ";\n  color: ", ";\n  height: 1.8rem;\n  border-radius: 14px;\n  width: fit-content;\n  padding: ", " ", ";\n  border: ", ";\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: ", ";\n  font-size: ", ";\n  background: ", ";\n  color: ", ";\n  height: 1.8rem;\n  border-radius: 14px;\n  width: fit-content;\n  padding: ", " ", ";\n  border: ", ";\n  ", "\n"])), theme_1.theme.fontWeights.medium, theme_1.theme.fontSizes.small, exports.badges[type].backgroundColor, exports.badges[type].color, theme_1.theme.space.space4, theme_1.theme.space.space12, exports.badges[type].borderColor
        ? "1px solid ".concat(exports.badges[type].borderColor)
        : 'none', StatusBadgeSizeVariants[size]);
};
var StatusBadgeSizeVariants = {
    regular: "\n    gap: 6px;\n  ",
    small: "\n    padding: 0.3125rem ".concat(theme_1.theme.space.space8, "; // 0.3125rem = 5px\n    height: ").concat(theme_1.theme.space.space24, ";\n    border-radius: 12px;\n  "),
    mini: "\n    width: ".concat(theme_1.theme.space.space24, ";\n    height: ").concat(theme_1.theme.space.space24, ";\n    border-radius: 12px;\n    padding: 0;\n  "),
};
var StyledStatusBadgeLink = (0, styled_1.default)(react_aria_components_1.Link)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-decoration: none;\n  cursor: pointer;\n  ", "\n  ", "\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:active {\n    background: ", ";\n  }\n"], ["\n  text-decoration: none;\n  cursor: pointer;\n  ", "\n  ", "\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:active {\n    background: ", ";\n  }\n"])), StatusBadgeStyles, focusRingStyles_1.FocusRingStyles, function (props) {
    return exports.badges[props.type].hoverBackgroundColor ||
        exports.badges[props.type].backgroundColor;
}, function (props) {
    return exports.badges[props.type].pressedBackgroundColor ||
        exports.badges[props.type].backgroundColor;
});
var StatusBadgeLink = function (_a) {
    var type = _a.type, size = _a.size, children = _a.children, props = __rest(_a, ["type", "size", "children"]);
    var icon = exports.badges[type].icon;
    return children ? (React.createElement(StyledStatusBadgeLink, __assign({ type: type, size: 'regular' }, props),
        icon,
        children)) : (React.createElement(StyledStatusBadgeLink, __assign({ type: type, size: size }, props), icon));
};
exports.StatusBadgeLink = StatusBadgeLink;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map